import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=73f6d59a&scoped=true&"
import script from "./ChatView.vue?vue&type=script&lang=ts&"
export * from "./ChatView.vue?vue&type=script&lang=ts&"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=73f6d59a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f6d59a",
  null
  
)

export default component.exports